var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 7.44772 2.44772 7 3 7H4C4.55228 7 5 7.44772 5 8V14C5 14.5523 4.55228 15 4 15H3C2.44772 15 2 14.5523 2 14V8Z",
    fill: "#00ADEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C7 1.44772 7.44772 1 8 1H9C9.55228 1 10 1.44772 10 2V14C10 14.5523 9.55228 15 9 15H8C7.44772 15 7 14.5523 7 14V2Z",
    fill: "#00ADEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 5.44772 12.4477 5 13 5H14C14.5523 5 15 5.44772 15 6V14C15 14.5523 14.5523 15 14 15H13C12.4477 15 12 14.5523 12 14V6Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartbar);
export default __webpack_public_path__ + "static/media/chartbar.8116fe6d5b4efcf03a2ac4a00888755f.svg";
export { ForwardRef as ReactComponent };